import { useSelector } from 'react-redux';

import type { RootState } from 'modules';

export default function useUI() {
  const toasts = useSelector((state: RootState) => state.ui.toasts);

  return {
    toasts,
  };
}
